import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import { useDialog } from '../../dialog/hook'

import GoodreadsGuide from './goodreads-guide'

type GoodredsImportDialogProps = {
  onImportStarted?: () => void
}

const GoodreadsImportDialog: React.FunctionComponent<GoodredsImportDialogProps> = ({ onImportStarted }) => {
  const { closeDialog } = useDialog()

  return (
    <Container>
      <GoodreadsGuide onImportStarted={() => {
        onImportStarted && onImportStarted()
        closeDialog()
      }}/>
    </Container>
  )
}


const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
  max-width: 1024px;

	padding: 24px;

	${up('tablet')} {
		padding: 64px;
	}
`

export default GoodreadsImportDialog